import './App.css';
import Component from './components/Component';

function App() {
	return <Component />
}

export default App;
